import { Action } from 'redux'
import * as constants from '../constants'
import {AssetGroup, CurrentMarketState, LoginSuccess, Prices, ServerType} from '@bdswiss/mt4-connector'

export interface LoginToMt4 extends Action {
  type: constants.LOGIN_TO_MT4
  login: string
  token?: string
  server: ServerType
}

export function loginToMt4(login: string, server: ServerType, token?: string): LoginToMt4 {
  return {
    type: constants.LOGIN_TO_MT4,
    login,
    token,
    server,
  }
}

export interface ReLoginToMt4 extends Action {
  type: constants.RELOGIN_TO_MT4
}

export function reloginToMt4(): ReLoginToMt4 {
  return {
    type: constants.RELOGIN_TO_MT4,
  }
}

export interface FulfillLogin extends Action {
  type: constants.FULFILL_LOGIN
  loginSuccess: LoginSuccess
  serverType?: ServerType
}

export function fulfillLogin(loginSuccess: LoginSuccess, serverType?: ServerType): FulfillLogin {
  return {
    type: constants.FULFILL_LOGIN,
    loginSuccess,
    serverType,
  }
}

export interface FulfillPrices extends Action {
  type: constants.FULFILL_PRICES
  prices: Prices
}

export function fulfillPrices(prices: Prices): FulfillPrices {
  return {
    type: constants.FULFILL_PRICES,
    prices,
  }
}

export interface FulfillCurrentMarketState extends Action {
  type: constants.FULFILL_CURRENT_MARKET_STATE,
  marketState: CurrentMarketState
}

export function fulfillCurrentMarketState(marketState: CurrentMarketState): FulfillCurrentMarketState {
  return {
    type: constants.FULFILL_CURRENT_MARKET_STATE,
    marketState
  }
}

export interface FulfillAssetGroups extends Action {
  type: constants.FULFILL_ASSET_GROUPS
  assetGroups: AssetGroup[]
}

export function fulfillAssetGroups(assetGroups: AssetGroup[]): FulfillAssetGroups {
  return {
    type: constants.FULFILL_ASSET_GROUPS,
    assetGroups,
  }
}
